import React from 'react';
import { Container, Box, Grid, Typography } from '@mui/material';
import {
    LockOutlined as LockOutlinedIcon,
    VisibilityOffOutlined as VisibilityOffOutlinedIcon,
    VerifiedUserOutlined as VerifiedUserOutlinedIcon
} from '@mui/icons-material';

const TrustSection = () => {
    return (
        <Box sx={{ py: 6, bgcolor: 'white' }}>
            <Container maxWidth="lg">
                <Typography
                    variant="h5"
                    sx={{
                        textAlign: 'center',
                        fontWeight: 'bold',
                        color: 'grey.800',
                        mb: 4
                    }}
                >
                    Twój plan działania powstaje na Twoich warunkach
                </Typography>
                <Grid container spacing={4} justifyContent="center">
                    <Grid item xs={12} md={4} textAlign="center">
                        <LockOutlinedIcon sx={{ fontSize: 40, color: 'primary.main', mb: 1 }} />
                        <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'grey.800' }}>
                            Bezpieczeństwo
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={4} textAlign="center">
                        <VisibilityOffOutlinedIcon sx={{ fontSize: 40, color: 'primary.main', mb: 1 }} />
                        <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'grey.800' }}>
                            Anonimowość
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={4} textAlign="center">
                        <VerifiedUserOutlinedIcon sx={{ fontSize: 40, color: 'primary.main', mb: 1 }} />
                        <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'grey.800' }}>
                            Poufność
                        </Typography>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default TrustSection;
